
import { RevCarousel, RevIllustration } from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { COUNTRIES } from '@config/constants'

import translations from '../Gallery/Gallery.translations'

import { SOCIAL_PROOF_IMAGES } from './SocialProof.constant'

export default {
  components: {
    RevCarousel,
    RevIllustration,
  },

  computed: {
    translations: () => translations,
    ...mapGetters({
      country: 'config/country',
    }),

    tracking() {
      return { name: 'social-proof' }
    },

    carouselImages() {
      switch (this.country) {
        case COUNTRIES.FR:
          return SOCIAL_PROOF_IMAGES[COUNTRIES.FR]
        case COUNTRIES.US:
          return SOCIAL_PROOF_IMAGES[COUNTRIES.US]
        case COUNTRIES.ES:
          return SOCIAL_PROOF_IMAGES[COUNTRIES.ES]
        case COUNTRIES.DE:
          return SOCIAL_PROOF_IMAGES[COUNTRIES.DE]
        default:
          return []
      }
    },

    shouldDisplayCarousel() {
      return !isEmpty(this.carouselImages)
    },
  },
}
